import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseDetailV2 } from 'src/app/shared/common-structures/case-detail';

@Component({
	selector: 'app-shared-edit-systemic-search-cases',
	templateUrl: './shared-edit-systemic-search-cases.component.html',
	styleUrls: ['./shared-edit-systemic-search-cases.component.scss'],
})
export class SharedEditSystemicSearchCasesComponent implements OnInit {
	newCharges: CaseDetailV2[];
	oldCharges: CaseDetailV2[];
	retained: CaseDetailV2[];
	removed: CaseDetailV2[];
	added: CaseDetailV2[];

	constructor(
		public dialogRef: MatDialogRef<SharedEditSystemicSearchCasesComponent>,
		@Inject(MAT_DIALOG_DATA) public data
	) {}

	ngOnInit(): void {
		this.newCharges = this.data.newCharges || [];
		this.oldCharges = this.data.oldCharges || [];
		this.retained = this.newCharges.filter((i) =>
			this.oldCharges.find((_old) => _old.ciChargeInquiryId === i.ciChargeInquiryId)
		);
		this.removed = this.oldCharges.filter(
			(i) => !this.newCharges.find((_new) => _new.ciChargeInquiryId === i.ciChargeInquiryId)
		);
		this.added = this.newCharges.filter(
			(i) => !this.oldCharges.find((old) => old.ciChargeInquiryId === i.ciChargeInquiryId)
		);
	}

	apply() {
		this.dialogRef.close({ newCharges: this.newCharges, removed: this.removed });
	}

	cancel() {
		this.dialogRef.close();
	}
}
